import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DialogModalService, FilesService, PermissionService } from 'src/app/services';
import { ApiProductsService } from 'src/app/services/api-products.service';
import { ImagesComponent } from 'src/app/components/dialog/images/images.component';
import { AddinfoDataAttr, AddinfoDataGroup } from 'src/app/models';
import { GalleryService, GridLayout, Image, PlainGalleryConfig, PlainGalleryStrategy } from '@ks89/angular-modal-gallery';

@Component({
  selector: 'app-product-profile',
  templateUrl: './product-profile.component.html',
  styleUrls: ['./product-profile.component.css']
})
export class ProductProfileComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  id: string;
  basisData: any;
  addinfoData: AddinfoDataGroup[] = []; // использовать если потребуется вывести дополнительные дынные в первом блоке рядом с фото.
  images: any[] = [];
  gallaryImages: any[] = [];
  isGalleryOpen: boolean;
  mainImage: any;

  plainGalleryGrid: PlainGalleryConfig = {
    strategy: PlainGalleryStrategy.GRID,
    layout: new GridLayout({ width: '48px', height: '48px' }, { length: 1, wrap: false })
  };

  constructor(
    private apiProductService: ApiProductsService,
    private fileService: FilesService,
    private currentRoute: ActivatedRoute,
    private router: Router,
    private dialogModal: DialogModalService,
    public permissionAccess: PermissionService,
    private galleryService: GalleryService
  ) { }

  ngOnInit(): void {

    this.id = this.currentRoute.snapshot.paramMap.get('id');
    this.getBasisInfo();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getBasisInfo(): void {

    this.subscriptions.add(

      this.apiProductService.info(this.id).subscribe(response => { console.log('[RESPONSE] getProductInfo: ', response);

        if(response != null) {

          this.basisData = response.result;

          if(response.result.files != null){

            for(let i = 0; i < response.result.files.length; i++){ 
            
              this.getImageContent(i, response.result.files[i]);
              this.getImages(i, response.result.files[i]);
            }
          }
        }
      })
    );
  }


  /**
   * 
   * @param index 
   * @param image 
   */
  getImageContent(index: number, image: any): void {
  
    if (image && image != null) {

      this.subscriptions.add(
        this.fileService.getImageContent(image.file_id).subscribe((response: any) => { 
        

          if (response != null) {

            this.images.push({ index: index, content: response.result });

            this.images.sort(function(a, b) {
              return a.index - b.index;
            });

            this.mainImage = this.images[0];
          }
        })
      );
    }
  }

   /**
   * 
   * @param product 
   */
    getImages(index: number, image: any): void {

      if (image && image != null) {
  
        this.subscriptions.add(
          this.fileService.getImages(this.id).subscribe((response: any) => {           
  
            if (response != null) {
  
              this.gallaryImages = response.result.map((url, index) => {
  
                return new Image(index, { img: url })
              });
              
            }
          })
        );
      }
    }

  /**
   * 
   * @param id 
   */
  openModalViaService() {

    this.isGalleryOpen = true;
    this.galleryService.openGallery(0, 0);
  }


  /**
   * 
   * @param image
   */
  swithMainImg(image): void {

    this.mainImage = image;
  }


  /**
   *
   * @param file
   */
  openImage(file: any): void {

    this.dialogModal.open(file, ImagesComponent, 'lg', 'images-window').then();
  }


  /**
   * 
   */
  onEdit(): void {

    this.router.navigate(['products', 'edit', this.id]);
  }


  /**
   * 
   * @param data AddinfoDataGroup[]
   */
  setProductData(data: AddinfoDataGroup[]): void {

    this.addinfoData = data;
  }


  /**
   * 
   * @param groupId 
   * @param attrId 
   * @returns 
   */
  getAttrData(groupId: string, attrId: string): AddinfoDataAttr { 

    let gIndex = this.addinfoData.findIndex(val => val.attribute_group_id == groupId);

    if(gIndex > -1){

      let aIndex = this.addinfoData[gIndex].attributes.findIndex(val => val.attribute_id == attrId);

      if(aIndex > -1){

        return this.addinfoData[gIndex].attributes[aIndex];
      }
    }

    return null;
  }


  /**
   * 
   * @param groupId 
   * @param attrId 
   * @returns 
   */
  getAttrValue(groupId: string, attrId: string): string {

    let attr: AddinfoDataAttr = this.getAttrData(groupId, attrId);

    return attr ? attr.attribute_value : null;
  }


  /**
   * 
   * @param groupId 
   * @param attrId 
   * @returns 
   */
  getAttrName(groupId: string, attrId: string): string {

    let attr: AddinfoDataAttr = this.getAttrData(groupId, attrId);

    return attr ? attr.attribute_name : null;
  }
}
